const LAKH = 100000;
const CRORE = 10000000;

export const formatValueInRupees = (rawValue) => {
    if (rawValue === undefined || rawValue === null) return rawValue;
    const strVal = String(rawValue);
    if (strVal.includes('₹') || /cr|lakh|l\b/i.test(strVal)) return rawValue;
    const numericValue = typeof rawValue === 'string'
        ? parseFloat(rawValue.replace(/[^0-9.]/g, ''))
        : Number(rawValue);
    if (isNaN(numericValue)) return rawValue;
    const formatNum = (num, digits = 1) =>
        new Intl.NumberFormat('en-IN', { maximumFractionDigits: digits, minimumFractionDigits: 0 }).format(num);
    if (numericValue >= CRORE) return `₹ ${formatNum(numericValue / CRORE)}Cr`;
    if (numericValue >= LAKH) return `₹ ${formatNum(numericValue / LAKH)}L`;
    return `₹ ${formatNum(numericValue)}`;
};
